export default __webpack_public_path__ + "static/media/editicon.9d774ff3.svg";